const headerContainer = document.querySelector( '.header-container' );
const header = document.querySelector( '.header' );
const boxSearch = document.querySelector( '.box-search' );

function updateHeaderState() {
	header?.classList.toggle( 'active', window.scrollY > 100 );
}

function updateHeaderHeight() {
	if ( ! headerContainer ) return;
	document.documentElement.style.setProperty(
		'--header-height',
		`${ headerContainer.offsetHeight }px`
	);
}

function updateBoxSearchTop() {
	if ( ! headerContainer || ! boxSearch ) return;

	if ( boxSearch.classList.contains( 'active' ) ) {
		boxSearch.style.top = `${ headerContainer.offsetHeight }px`;
	} else {
		boxSearch.style.top = '';
	}
}

window.addEventListener( 'scroll', () => {
	updateHeaderState();
	updateBoxSearchTop();
} );

window.addEventListener( 'resize', () => {
	updateHeaderHeight();
	updateBoxSearchTop();
} );

const observer = new MutationObserver( () => {
	updateBoxSearchTop();
} );

if ( boxSearch ) {
	observer.observe( boxSearch, {
		attributes: true,
		attributeFilter: [ 'class' ],
	} );
}

updateHeaderState();
updateHeaderHeight();
updateBoxSearchTop();
